/* eslint-disable react/prop-types */
import React, { useEffect, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Checkbox, Button, message } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Header, Title } from '$app/shared/components/Header';
import Loading from '$app/shared/components/Loading';
import { getCampaignById, updateCampaign } from '../CampaignEditPage/actions';
import { listAllProducts } from '../CampaignRequiredItemsPage/actions';
import Menu from '../../components/Menu';
import Styled from '../CampaignRequiredItemsPage/styled';

const CheckboxGroup = Checkbox.Group;

const CampaignAffectedItemsPage = ({ history, match }) => {
  const campaignId = match.params.campaignId;
  const [state, setState] = useState({
    campaign: {},
    products: [],
    affectedItems: [],
  });

  const { campaign, products, affectedItems } = state;

  useEffect(() => {
    const fetchData = async () => {
      const response = await Promise.all([getCampaignById(campaignId), listAllProducts()])
        .then(([campaignData, allProducts]) =>
          setState((prevState) => ({
            ...prevState,
            campaign: campaignData,
            products: allProducts,
            affectedItems: campaignData.affectedItems.length ? campaignData.affectedItems : allProducts,
          }))
        )
        .catch((err) => {
          message.error(err);
        });
      return response;
    };
    fetchData();
  }, [campaignId]);

  const closePageHandler = useCallback(() => history.push('/'), [history]);

  const onChange = (newCheckList) =>
    setState((prevState) => ({
      ...prevState,
      affectedItems: newCheckList,
    }));

  const onCheckAllChange = (e) => {
    if (e.target.checked) {
      return setState((prevState) => ({
        ...prevState,
        affectedItems: products,
      }));
    }
    return setState((prevState) => ({
      ...prevState,
      affectedItems: [],
    }));
  };

  const saveAffectedItems = () => {
    let items = affectedItems;
    /**
     * By default campaigns are applied on all items, and in the DB we save it as an empty array.
     * For easier understanding on the UI side, the checkbox of all items are ticked by default when we
     * don't specify the items affected; while on saving the items we still keep the affectedItems field
     * as an empty array.
     */
    if (affectedItems.length === products.length) {
      items = [];
    }
    return updateCampaign(campaignId, {
      affectedItems: JSON.stringify(items),
    })
      .then(() => message.info('Campaign affected items have been updated'))
      .catch((error) => message.error(get(error, 'response.data.message') || 'Could not update campaign', 3));
  };

  if (isEmpty(campaign)) return <Loading />;

  return (
    <Styled className="CampaignAffectedItemsPage">
      <Header className="justify">
        <Title>
          Campaign {campaignId}
          <Button type="link" onClick={closePageHandler} className="pull-right">
            <img src="/assets/images/close-black.svg" alt="close" style={{ cursor: 'pointer', height: 20 }} />
          </Button>
        </Title>
      </Header>
      <Menu selectedItem="affectedItems" campaignId={campaignId} history={history} />

      <div className="products">
        <Checkbox onChange={onCheckAllChange} checked={products.length === affectedItems.length}>
          Select all products
        </Checkbox>

        <div className="line" />

        <CheckboxGroup options={products} value={affectedItems} onChange={onChange} />

        <Button onClick={saveAffectedItems}>Save</Button>
      </div>
    </Styled>
  );
};

export default withRouter(CampaignAffectedItemsPage);
